import React from 'react'

function ManageReview() {
  return (
    <div>
      <p>Manage Review</p>
    </div>
  )
}

export default ManageReview
